import React from 'react'
// libs
import get from 'lodash/get'
import styled, { css } from 'styled-components'
// components
import NodeContent from 'components/PageComponents/Plans/Edit/components/MinimizedObjectivesList/ObjectivesTreeTheme/NodeContent' // constants
import { ENTITIES } from 'constants/entities'
import { NODE_CONTENT_RENDERER_SIZES } from 'constants/index' // themes
import colors from 'themes/colors'
import { transparentize } from 'polished' // views
import { CollapseIcon, ContentInnerWrapper, ContentWrapper, IconsWrapper } from 'themes/views/objectivesList' // utils
import { isColorLight } from 'utils/tree'

const Wrapper = styled('div')<{ $background: string }>`
  display: flex;
  cursor: pointer;
  border-radius: 5px;
  height: ${NODE_CONTENT_RENDERER_SIZES.NODE_HEIGHT}px;

  ${({ $background }) => isColorLight($background) && `border: 1px solid ${colors.gray290}`};

  ${({ $background }) =>
    $background &&
    css`
      background: ${$background};

      &:hover {
        background: ${transparentize(0.2, $background)};
      }
    `};
`

const MinimalThemeNodeContentRenderer = ({
  node,
  title,
  path,
  style,
  treeIndex,
  toggleChildrenVisibility,
  ...rest
}) => {
  const nodeTitle = title || node.title

  const handleCollapseClick = (event: React.MouseEvent) => {
    event.stopPropagation()

    toggleChildrenVisibility({ node, path, treeIndex })
  }

  const color = get(node, 'color')
  const hasChildren = !!get(node, 'children.length')

  const isRootObjective = !node.parentId && node.entityType === ENTITIES.PLAN_OBJECTIVE
  const isObjective = node.entityType === ENTITIES.PLAN_OBJECTIVE
  const isAction = node.entityType === ENTITIES.PLAN_ACTION
  const isKPI = node.entityType === ENTITIES.PLAN_KPI

  return (
    <>
      <Wrapper {...rest} $background={isRootObjective && color}>
        <IconsWrapper
          $isKPI={isKPI}
          $background={color}
          $isAction={isAction}
          $isRoot={isRootObjective}
          $isObjective={isObjective}>
          {hasChildren && isObjective && (
            <CollapseIcon onClick={handleCollapseClick} $isExpanded={node.expanded} color={'inherit'} />
          )}
        </IconsWrapper>
        <ContentWrapper
          $isKPI={isKPI}
          $background={color}
          $isAction={isAction}
          $isRoot={isRootObjective}
          $isObjective={isObjective}
          onClick={node.handleClick}>
          <ContentInnerWrapper style={style}>
            <NodeContent
              node={node}
              isKPI={isKPI}
              background={color}
              isAction={isAction}
              nodeTitle={nodeTitle}
              isRoot={isRootObjective}
              isObjective={isObjective}
              hasChildren={hasChildren}
              handleCollapseClick={handleCollapseClick}
            />
          </ContentInnerWrapper>
        </ContentWrapper>
      </Wrapper>
    </>
  )
}

MinimalThemeNodeContentRenderer.defaultProps = {
  style: {},
  title: null,
  toggleChildrenVisibility: null
}

// MinimalThemeNodeContentRenderer.propTypes = {
//   node: shape({}).isRequired,
//   path: arrayOf(oneOfType([string, number])).isRequired,
//   style: shape({}),
//   title: oneOfType([func, node]),
//   toggleChildrenVisibility: func,
//   treeIndex: number.isRequired
// }

export default MinimalThemeNodeContentRenderer
